module.exports = __webpack_public_path__ + "assets/img/_Novo RDR_Playground_RGB_lr.f4e9410f.jpg";